import React, { useState, Fragment, useEffect, useCallback, useRef } from 'react';
import { Button, Accordion, Card, Form, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import TimeLine from './TimeLine/TimeLine';
import { FUTURE, FUTURE_PRACTICE, LIVE, LIVE_PRACTICE, PAST, PAST_PRACTICE } from '../../../config/constants';
import { useDataEventsState } from 'store/hooks';
import { useManageDispatch } from 'store/hooks/manage';
import { text_truncate } from 'helpers';
import { useCustomEventsDispatch } from 'store/hooks/customEvents';
import { customEventsType } from 'config/commonTypes';
type PlayLoggerProps = {
  open:boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isInProgressPeriod: boolean;
  updateQueue: {
    queue: any[];
    fetching: number;
  };
  customEventsButtons:customEventsType;
  setUpdateQueue: React.Dispatch<React.SetStateAction<{
    queue: any[];
    fetching: number;
  }>>
}
export default ({ open, setOpen, isInProgressPeriod, updateQueue, setUpdateQueue, customEventsButtons = [
  {
  name: '-' ,
  displayName: 'CustomBOne',
  num: 1
  },
  {
    name: '-',
    displayName: 'customBTwo',
    num: 2
  },
  {
    name: '-',
    displayName: 'customBThree',
    num: 3
  }
] }:PlayLoggerProps) => {
  const { dataEvent, data:manageData, meta } = useDataEventsState();
  const teamId = meta.homeTeam.teamId;
  const practice = manageData.manage;
  const eventId = meta._id;
  const league = meta.league;
  const {updatePractice} = useManageDispatch();
  const [checked, setChecked] = useState({
    Handoff: 0,
    Throw: 0,
    Rep: 0,
    Catch: 0,
    Incomplete: 0,
    Kick: 0,
    Tackle: 0,
    Snap: 0,
    // eslint-disable-next-line no-useless-computed-key
    ['End Play']: 0
  });
  
  const [editCustomEvt, setEditCustomEvt]=useState(false);
  const { updateCustomEvents } = useCustomEventsDispatch();
  const [practiceCopy, setPracticeCopy] = useState(JSON.parse(JSON.stringify(practice)));
  const timer = useRef<null | NodeJS.Timeout>(null);

  const customButtonOne = customEventsButtons.find((number)=> number.num === 1)?.name || '-';
  const customButtonTwo = customEventsButtons.find((number)=> number.num === 2)?.name || '-';
  const customButtonThree = customEventsButtons.find((number)=> number.num === 3)?.name || '-';
  
  const [customEventOne, setCustomEventOne] = useState('');
  const [customEventTwo, setCustomEventTwo] = useState('');
  const [customEventThree, setCustomEventThree] = useState('');
  const dataButtons = [
    { class: 'bb-ss', label: 'Handoff' },
    { class: 'bb-ss', label: 'Throw' },
    { class: 'bb-vv', label: 'Rep' },
    { class: 'bb-ss', label: 'Catch' },
    { class: 'bb-ss', label: 'Incomplete' },
    { class: 'bb-vv', label: 'Kick' },
    { class: '', label: 'Tackle' }
  ];
  const customButtons = [
    {class: 'bb-vv', label: customButtonOne },
    {class: 'bb-ss', label: customButtonTwo},
    {class: 'bb-ss', label: customButtonThree}
  ];
  const handleEditSwithc = ()=>{
    if(!editCustomEvt){
      setEditCustomEvt(true);
      setCustomEventOne(customButtonOne);
      setCustomEventTwo(customButtonTwo);
      setCustomEventThree(customButtonThree);
    }else{
      setEditCustomEvt(false);
      resetCustomEvents();
    }
  };
  const handleCustomEventChange = (event:any, index:number) => {
    if(index === 0){
      setCustomEventOne(event.target.value);
    }else if(index > 0 && index < 2){
      setCustomEventTwo(event.target.value);
    }else{
      setCustomEventThree(event.target.value);
    }
    
};
const handleCustomEventSave = () =>{
    updateCustomEvents(customEventOne, customEventTwo, customEventThree, teamId);
    setEditCustomEvt(false);
};
const resetCustomEvents = () =>{
  setCustomEventOne(customButtonOne);
  setCustomEventTwo(customButtonTwo);
  setCustomEventThree(customButtonThree);
  
};
  const updateEventsPractice = useCallback(async (label) => {
    if (dataEvent.meta.type !== LIVE_PRACTICE) {
      return;
    }
    if (!practiceCopy.events) {
      practiceCopy.events = [];
    }
    const now = new Date().getTime();
    practiceCopy.events.push({ type: label, timeStamp: now });
    if(timer.current){
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(async () => {
     await updatePractice(practiceCopy, eventId, league, meta.type, false);
      }, 2000);
    setChecked(prevState => ({ ...prevState, [label]: prevState[label] - 1 }));
  }, [checked, dataEvent.meta.type, eventId, league, practice, updatePractice]);

  useEffect(() => { 
    setPracticeCopy(JSON.parse(JSON.stringify(practice)));
  },[practice]);

  useEffect(() => {
    if (updateQueue.queue.length && !updateQueue.fetching) {
      setUpdateQueue(prevState => ({ ...prevState, fetching: 1 }));
      updateEventsPractice(updateQueue.queue[0]).then(() => {
        setUpdateQueue(prevState => ({ queue: prevState.queue.slice(1), fetching: 0 }));
      });
    }
  }, [updateQueue]);
  
  const handleSaveClick = (label:string) => {
    setUpdateQueue(prevState => ({ queue: [...prevState.queue, label], fetching: prevState.fetching }));
    setChecked({ ...checked, [label]: checked[label] + 1 });
  };

  const stamps = JSON.parse(JSON.stringify(practice.events ? practice.events : []));
  if (practice.start) {
    stamps.push({ type: 'Practice Start', timeStamp: practice.start ? practice.start : 0, shape: 'circle' });
  }
  if (dataEvent.meta.type === PAST_PRACTICE) {
    stamps.push({ type: 'Practice End', timeStamp: practice.end ? practice.end : 0, shape: 'circle' });
  }
  const tooltip = (val?: string) => {
    if (val) {
      return (
        <Tooltip id="tool">
          <div style={{ color: '#0A6F9A' }}>{val}</div>
        </Tooltip>
      );
    }
    return <Tooltip hidden={true} id="no_tooltip" />;
  };
  return (
    <div className="accor-play">
      <Accordion activeKey={open ? '0' : ''}>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey={''+open} onClick={() => setOpen(!open)}>
              <div className="ac-p">
                <div className="log-pp">
                  <img src="/assets/icon-log.svg" alt="" />
                  Log Plays
                </div>
                <div className="op-cc">
                  {open ? 'MINIMIZE' : 'OPEN'}
                  <img src="/assets/icon-arrow.svg" alt="" style={open ? { transform: 'rotate(180deg)' } : {}} />
                </div>
              </div>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0" mountOnEnter unmountOnExit>
            <Card.Body>
              <div className="buton-ac">
                <form>
                  <div
                    className="button-group"
                    style={!isInProgressPeriod ? { opacity: '0.5', pointerEvents: 'none' } : {}}
                  >
                    {dataButtons.map((data) => (
                      <Fragment key={data.label}>
                        <input
                          id={'checkbox-' + data.label}
                          type="checkbox"
                          checked={checked[data.label]}
                          readOnly
                          onClick={() => handleSaveClick(data.label)}
                          disabled={dataEvent.meta.type !== LIVE_PRACTICE}
                        />
                        <label className={'button ' + data.class} htmlFor={'checkbox-' + data.label}>
                          <img src="/assets/icon-check.svg" height="18px" alt={data.label} />{data.label}</label>
                      </Fragment>
                    ))}
                  </div>
                </form>
              </div>
              <div className="buton-acc">
                <form>
                  <div
                    className="button-group"
                    style={!isInProgressPeriod ? { opacity: '0.5', pointerEvents: 'none' } : {}}
                  >
                    <input
                      id="checkbox8"
                      type="checkbox"
                      checked={!!checked.Snap}
                      readOnly
                      onClick={() => handleSaveClick('Snap')}
                    />
                    <label className="button bb-nn" htmlFor="checkbox8">
                      <img src="/assets/icon-check.svg" height="24px" alt={'Snap'} />Snap
                    </label>
                    <input
                      id="checkbox9"
                      type="checkbox"
                      checked={!!checked['End Play']}
                      readOnly
                      onClick={() => handleSaveClick('End Play')}
                    />
                    <label className="button" htmlFor="checkbox9">
                      <img src="/assets/icon-check.svg" height="24px" alt={'End Play'} />End Play
                    </label>
                  </div>
                </form>
                <div className="buton-ac-custom" >
                      <form>
                       {!editCustomEvt? 
                       <div style={!isInProgressPeriod ? { opacity: '0.5', pointerEvents: 'none' } : {}}>
                      {customButtons.map((data, index) => (
                      <Fragment key={index} >
                        <input
                          id={'checkbox-' + data.label}
                          type="checkbox"
                          checked={checked[data.label]}
                          readOnly
                          onClick={() => handleSaveClick(data.label)}
                          disabled={dataEvent.meta.type !== LIVE_PRACTICE}
                          style={{display: "none"}}
                        />
                        <OverlayTrigger
                        placement="bottom"
                        overlay={tooltip(data.label)}
                        key={index}
                        >
                        <label className={'button-001 ' + data.class} htmlFor={'checkbox-' + data.label} style={data.label === '-' ? { opacity: '0.5', pointerEvents: 'none' }:{}}>
                        <img src="/assets/icon-check.svg" height="18px" alt={data.label} />{text_truncate(data.label, 10)}</label></OverlayTrigger>
                      </Fragment>))}
                      </div>
                      :
                      <Form>
                      <Row className="mb-2" style={{width:'550px', marginTop:'10px'}}>
                      {customButtons.map((data, index) => (
                      <Form.Group as={Col} controlId="formGridEmail" key={index} >
                        <Form.Label style={{
                          fontSize: '12px',
                          color: '#007ABA',
                          fontFamily:'$condensed'}}>{`Set Custom Event ${index +1}`}</Form.Label>
                        <Form.Control type="text" placeholder={data.label} onChange={(e)=>handleCustomEventChange(e,index)} />
                      </Form.Group>
                  
                    ))}
                  </Row>
                  </Form>
                      }
                  </form>
                    <div className="manage-btn-events">
                      <div className={'switch-00'} >
                        <label onClick={() =>handleEditSwithc()} className="label-009" id="label-editing-custom-events"> {'Edit '}</label>
                          <input
                            type="checkbox" id="editing-custom-events" name="set-name" className="switch-input"
                            checked={ editCustomEvt}
                            onChange={() =>handleEditSwithc()}
                          />
                        <label htmlFor="editing-custom-events" id="editing-custom-events" className="switch-label" />
                      </div>
                  </div>
            {
              editCustomEvt?
              <Button
                className="btn-green"
                style={{marginTop: '35px'}}
                onClick={()=>{
                handleCustomEventSave();}}
                >
                  Save
              </Button>
              :
              ''
            }
          </div>

          </div>
              <div className="time-line00">
                <TimeLine
                  width={1221}
                  height={63}
                  data={{
                    stamps: stamps,
                    periods: practice.drills ? practice.drills
                      .filter(drill => !!drill.startTs)
                      .map(drill => ({
                        type: 'period',
                        timeStamp: drill.startTs,
                        timeStampEnd: drill.endTs ? drill.endTs : new Date(),
                        shape: 'none',
                        name: drill.drillType
                      })) : [],
                    plusSlack: 1000 * 60,
                    slack: (1000 * 60) / 2,
                    status: dataEvent.meta.type === LIVE_PRACTICE ? LIVE : (dataEvent.meta.type === FUTURE_PRACTICE ? FUTURE : PAST)
                  }}
                />
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};
